import { Component, Prop, Vue} from "vue-property-decorator";
import { ProductListCustomModuleModel, Product, UiState, ConfiguratorValueUpdateModel, VariantHeightOrWeightOptions, configuratorConstants } from "../models";
import { productConfiguratorStore as store } from "./../store";
import ProductSpecification from "./ProductSpecification";

@Component({
    components: {
        ProductSpecification
  }
})
export default class ProductListCustomModule extends Vue {
    @Prop()
    protected vm!: ProductListCustomModuleModel;
    protected productStates: Array<UiState<boolean>> = [];
    protected addedProducts: Product[] = [];
    protected selectedProduct: string = "";
    protected productsBeforeSelection: Product[] = [];
    protected selectedOptionWidth: number = 0;
    protected selectedOptionHeight: number = 0;
    protected selectedBaseProductHeightOptions: VariantHeightOrWeightOptions = {id : "", options: []};
    protected selectedBaseProductWidthOptions: VariantHeightOrWeightOptions = {id : "", options: []};


    protected created() {
        this.selectedProduct = "";

        if (this.vm.recommendedSectionProductFromCookie) {
            this.selectedProduct = this.vm.recommendedSectionProductFromCookie;
            this.getWidthHeightOptions();
            const updateModel: ConfiguratorValueUpdateModel = { moduleId: this.vm.id, value: this.vm.recommendedSectionProductFromCookie ?
                this.vm.recommendedSectionProductFromCookie : "", valueDescriptions: [{ title: "", text: "" }],
            propertyName: configuratorConstants.RecommendedSectionProducts, isText: false, resetClimateSavingsCookie: false };
            this.$emit("update-configurator-value", updateModel);
        }

        if (this.vm.selectedWidthFromCookie) {
            this.selectedOptionWidth = this.vm.selectedWidthFromCookie;
            const updateModelWidth: ConfiguratorValueUpdateModel = { moduleId: this.vm.id, value: this.vm.selectedWidthFromCookie ?
                this.vm.selectedWidthFromCookie : "", valueDescriptions: [{ title: "", text: this.vm.selectedWidthFromCookie.toString() }],
            propertyName: "SelectedWidth", isText: false, resetClimateSavingsCookie: false };
            this.$emit("update-configurator-value", updateModelWidth);
        }

        if (this.vm.selectedHeightFromCookie > 0) {
            this.selectedOptionHeight = this.vm.selectedHeightFromCookie;
            const updateModelHeight: ConfiguratorValueUpdateModel = { moduleId: this.vm.id, value: this.vm.selectedHeightFromCookie ?
                this.vm.selectedHeightFromCookie : "", valueDescriptions: [{ title: "", text: this.vm.selectedHeightFromCookie.toString() }],
            propertyName: configuratorConstants.edgeHeight, isText: false, resetClimateSavingsCookie: false };
            this.$emit("update-configurator-value", updateModelHeight);
        }

        this.vm.customProducts.forEach(p => this.productStates.push({ id: p.articleNumber} as UiState<boolean>));
    }

    protected toggleProductSpecification(product: Product) {
        const productStateIndex = this.productStates.findIndex(s => s.id === product.articleNumber);
        if (productStateIndex !== -1) {
            const productState = this.productStates[productStateIndex];
            productState.state = !productState.state;
            this.productStates.splice(productStateIndex, 1, productState);
        }
    }

    protected showProductSpecification(product: Product): boolean {
        const productState = this.productStates.find(s => s.id === product.articleNumber);
        if (productState) {
            return productState.state;
        }
        return false;
    }

    protected addProduct(product: Product) {
        this.vm.customProducts.map(a => {
            a.added = false;
        });
        this.selectedProduct = "";
        this.selectedProduct = product.articleNumber;

        this.getWidthHeightOptions();

        const updateModel: ConfiguratorValueUpdateModel = { moduleId: this.vm.id, value: this.selectedProduct, valueDescriptions: [{ title: "", text: "" }],
        propertyName: configuratorConstants.RecommendedSectionProducts, isText: false, resetClimateSavingsCookie: false };
        this.$emit("update-configurator-value", updateModel, true);
    }

    protected removeProduct(product: Product) {
        product.added = false;
        this.selectedProduct = "";
        this.getWidthHeightOptions();
        const updateModel: ConfiguratorValueUpdateModel = { moduleId: this.vm.id, value: this.selectedProduct, valueDescriptions: [{ title: "", text: "" }],
        propertyName: configuratorConstants.RecommendedSectionProducts, isText: false, resetClimateSavingsCookie: false };
        this.$emit("update-configurator-value", updateModel, true);
    }

    protected isProductAdded(product: Product): boolean {
        return  store.propertyModelValues.some(x => x.key === configuratorConstants.RecommendedSectionProducts
        && x.value && x.value === product.articleNumber);
    }

    protected getButtonText(product: Product): string {
        if (this.isProductAdded(product)) {
            return this.translations.selectedProductButtonText;
        }
        return this.translations.selectProductButtonText;
    }

    protected getWidthHeightOptions() {
        if (this.selectedProduct !== "") {
            const heightOptions = this.vm.customProductsHeightOptions.filter(x => x.id === this.selectedProduct);
            const widthOptions = this.vm.customProductsWidthOptions.filter(x => x.id === this.selectedProduct);
            if (heightOptions && heightOptions.length > 0) {
                this.selectedBaseProductHeightOptions = heightOptions[0];
                this.selectedOptionHeight = this.selectedBaseProductHeightOptions ? this.selectedBaseProductHeightOptions.options[0] : 0;

                const updateModel: ConfiguratorValueUpdateModel = { moduleId: this.vm.id, value: this.selectedOptionHeight, valueDescriptions: [{ title: "",
                text: this.selectedOptionHeight.toString() }], propertyName: configuratorConstants.edgeHeight, isText: false, resetClimateSavingsCookie: false };
                this.$emit("update-configurator-value", updateModel);
            }
            if (widthOptions && widthOptions.length > 0) {
                this.selectedBaseProductWidthOptions = widthOptions[0];
                this.selectedOptionWidth = this.selectedBaseProductWidthOptions ? this.selectedBaseProductWidthOptions.options[0] : 0;

                const updateModel: ConfiguratorValueUpdateModel = { moduleId: this.vm.id, value: 400, valueDescriptions: [{ title: "", text: "400" }],
                propertyName: configuratorConstants.edgeHeight, isText: false, resetClimateSavingsCookie: false };
                this.$emit("update-configurator-value", updateModel);
            }
        } else {
            this.selectedBaseProductHeightOptions = {id : "", options: []};
            this.selectedBaseProductWidthOptions = {id : "", options: []};
        }
    }

    protected onSelectedChangeWidth() {
        const updateModel: ConfiguratorValueUpdateModel = { moduleId: this.vm.id, value: this.selectedOptionWidth, valueDescriptions: [{ title: "", text: "" }],
        propertyName: "SelectedWidth", isText: false, resetClimateSavingsCookie: false };
        this.$emit("update-configurator-value", updateModel, true);
    }

    protected onSelectedChangeHeight() {
        const updateModel: ConfiguratorValueUpdateModel = { moduleId: this.vm.id, value: this.selectedOptionHeight, valueDescriptions: [{ title: "",
        text: this.selectedOptionHeight.toString() }], propertyName: configuratorConstants.edgeHeight, isText: false, resetClimateSavingsCookie: false };
        this.$emit("update-configurator-value", updateModel, true);
    }

    get products() {
        return this.vm.customProducts.sort((a, b) => {
            return a.name.localeCompare(b.name, "sv", { numeric: true});
          });
    }

    get hasDisplayedProducts() {
        return this.vm.customProducts.length > 0;
    }

    get translations() {
        return store.translations;
    }
}
